import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { formatEventDate } from '@shared/libs/format-event-date';
import { styles } from './styles';
import { styles as inviteStyles } from '@widgets/invite-status/styles';
import info from '@widgets/invite-status/assets/info.webp';

type UsedFormProps = {
  eventName: string;
  dateStart: string;
  dateEnd: string;
};

export const UsedForm: FC<UsedFormProps> = ({ eventName, dateStart, dateEnd }) => {
  const formattedDate = formatEventDate(dateStart, dateEnd);

  return (
    <div {...stylex.props(inviteStyles.content)}>
      <img src={info} alt="Форма заполнена" {...stylex.props(inviteStyles.statusIllustration)} />
      <div {...stylex.props(inviteStyles.titleContent)}>
        <p {...stylex.props(styles.date)}>{formattedDate}</p>
        <p {...stylex.props(styles.titleInfo)}>«{eventName}»</p>
      </div>
      <p {...stylex.props(styles.subTitleInfo)}>
        Спасибо, что заполнили форму. В ближайшее время мы свяжемся с вами для уточнения деталей
      </p>
    </div>
  );
};
